export const versionStatus=(row,product)=>{
 const actual=row[product+'Actual'],available=row[product+'Disponible'];
 if(!actual)return {key:'unknown',label:'Sin reporte',color:'default'};
 if(row[product+'Release'])return Number(row.equipos)>0&&Number(row[product+'Confirmados'])===Number(row.equipos)?{key:'current',label:'Confirmado',color:'success'}:{key:'pending',label:'Pendiente',color:'warning'};
 if(!available)return {key:'unknown',label:'Sin versión asignada',color:'default'};
 return actual===available?{key:'reported',label:'Coincide · reportado',color:'info'}:{key:'pending',label:'Pendiente',color:'warning'};
};
